import { COMMON_LAYOUT_TYPE } from "../../ListPresentation/components/Testimonials/Constants";
import { COLOR_DIFF_LAYOUT, FILTER_CUSTOM_CLASS_2, COLOUR, FILTER_CUSTOM_CLASS } from "../constant";
import ColorLayout2 from "./FilterLayouts/ColorLayout2";
import Layout1 from "./FilterLayouts/Layout1";
import RenderViewMoreAndLess from "./RenderViewMoreAndLess";

function RenderColourFilters(props) {
  const { data, config, filterName } = props;
  const { sortAndFilter: { appearances: { color = '' } = {} } = {} } = config || {};
  const layout_desktop = config?.sortAndFilter?.layout_desktop;

  function renderColourFilterAccToLayout(item) {
    switch (color) {
      case COMMON_LAYOUT_TYPE.ONE:
        return <Layout1 filterData={item} type={COLOUR} isSelect={false} filterName={filterName} />
      case COMMON_LAYOUT_TYPE.TWO:
      case COMMON_LAYOUT_TYPE.THREE:
        return <ColorLayout2 filterData={item} type={COLOUR} isSelect={false} filterName={filterName} isType2 = {color === COMMON_LAYOUT_TYPE.TWO}/>
    }
  }
  return (
      <RenderViewMoreAndLess
      isLayout2 = {layout_desktop === COMMON_LAYOUT_TYPE.TWO}
      data = {data}
      childComponent = {renderColourFilterAccToLayout}
      customClass = {COLOR_DIFF_LAYOUT?.includes(color) ? FILTER_CUSTOM_CLASS_2 : FILTER_CUSTOM_CLASS}
      />
  )
}

export default RenderColourFilters